import React, { useEffect, useState } from 'react';
import { Badge, Popover, message, Drawer, Space, notification as NotifcationUI } from 'antd';
import moment from "moment-timezone";
import { useSelector } from 'react-redux';
// import ReactHtmlParser from 'react-html-parser';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { AtbdTopDropdwon } from './auth-info-style';
import { EmailIcon, CancelIcon } from '../../Icons/Icons';
import { getSocket } from "../../../Api/Socket";
import { changeStatusforMails } from '../../../Api/Services/EmailApiSevices'
import { findRecivedEmailActivityByUser } from '../../../Api/Services/NotificationApiService';
import MailDetailView from '../../../container/dashboard/Email/MailDetailView';
// import { Popover } from '../../popup/popup';
import Heading from '../../heading/heading';
import EditNavPopup from '../../../container/dashboard/Popup/EditNavPopup'

const notificationIdsShown = new Set();

function NotificationBox() {
  const localData = useSelector((state) => state.localRedux);
  const ProfileData = localData.profile
  const profile = ProfileData
  const companyProfile = localData.company
  const storeSubcription = localData.subcription
  const edit = useSelector((state) => state.edit.edit);
  const { emailapiValues } = useSelector((state) => state.EmailData);
  const [notification, setNotification] = useState([])
  const [isNotification, setIsNotification] = useState(false)
  const [unseenCount, setUnseenCount] = useState(0)
  const [confirmPopup, setConfirmPopup] = useState(false)
  const [linkUrl, setLinkUrl] = useState()
  const [open, setOpen] = useState(false);
  const [emailPopup, setEmailPopup] = useState(false)
  const [popupType, setPopupType] = useState()
  const [emailOpenId, setEmailOpenId] = useState()
  const urlPathname = window.location.pathname;
  const urlSearch = window.location.search;
  const combinedUrl = urlPathname + urlSearch;
  function extractTimeZoneName(tzString) {
    const parts = tzString.split(" ");
    return parts[1];
  }
  const iconWrapper = {
    width: 36,
    height: 36,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: '#407fe9',
    backgroundColor: "#407fe915",
  };
  const { rtl } = useSelector(state => {
    return {
      rtl: state.ChangeLayoutMode.rtlData,
    };
  });
  function renderThumb({ style, ...props }) {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: '#F1F2F6',
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  }
  const renderTrackVertical = () => {
    const thumbStyle = {
      position: 'absolute',
      width: '6px',
      transition: 'opacity 200ms ease 0s',
      opacity: 0,
      [rtl ? 'left' : 'right']: '2px',
      bottom: '2px',
      top: '2px',
      borderRadius: '3px',
    };
    return <div className="hello" style={thumbStyle} />;
  };
  function renderView({ style, ...props }) {
    const customStyle = {
      marginRight: rtl && 'auto',
      [rtl ? 'marginLeft' : 'marginRight']: '-17px',
    };
    return <div {...props} style={{ ...style, ...customStyle }} />;
  }
  renderThumb.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };
  renderView.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };
  function highlightValuesInsideQuotes(message) {
    const regex = /"([^"]*)"/g;
    return message.replace(regex, '<span class="splTxt">$1</span>');
  }
  async function AllNotification() {
    try {
      const data = await findRecivedEmailActivityByUser()
      const SortedData = data.sort((a, b) => b.emailActivityId - a.emailActivityId);
      const highlightedMessages = SortedData.map(item => ({
        ...item,
        // message: item.message ? highlightValuesInsideQuotes(item.message) : item.message
        message: item.subject ? highlightValuesInsideQuotes(item.subject) : item.subject
      }));
      setNotification(highlightedMessages.slice(0, 9));
      const hasUnseen = highlightedMessages.slice(0, 9).some(notification => notification.status === "unseen");
      setIsNotification(hasUnseen)
      const count = highlightedMessages.slice(0, 9).filter(notification => notification.status === "unseen").length;
      setUnseenCount(count);
    } catch (error) {

      message.error(error);
    }
  }
  useEffect(() => {
    AllNotification();
  }, []);
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const handleChange = (newOpen, url) => {
    if (storeSubcription?.isActive) {
      setOpen(newOpen);
      if (edit) {
        setConfirmPopup(true)
        setLinkUrl(url)
      }
    }
    else {
      message.info("Your subscription is not active. Please renew to continue");
    }
  };
  const emailClose = () => {
    setEmailPopup(false)
    setPopupType()
    setEmailOpenId()
  }
  const ViewDetailPage = (id, type, userId, server, activityId) => {
    if (storeSubcription?.isActive) {
      setOpen(false);
      if (profile?.userId === userId) {
        if (server === emailapiValues?.emailType) {
          changeStatusforMails({}, activityId).catch(err => {
            console.error("Error fetching recent mails:", err);
          });
          setEmailPopup(true)
          setPopupType(type)
          setEmailOpenId(id)
          AllNotification()
        }
        else {
          message.info("Unable to retrieve the selected email. Please check your email settings or contact the administrator for support")
        }
      }
      else {
        message.info("Email details not found. Please contact your admin for details")
      }
    }
    else {
      message.info("Your subscription is not active. Please renew to continue");
    }
  }
  const convertTime = (timeStr, timeFormat) => {
    let hours;
    let minutes;
    // let seconds;
    let period;
    if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
      // Parse 12-hour time string
      const timeParts = timeStr.match(/(\d{1,2}):(\d{2}):?(\d{2})?/);
      hours = parseInt(timeParts[1], 10);
      minutes = parseInt(timeParts[2], 10);
      // seconds = parseInt(timeParts[3], 10);
      period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

      if (period === 'pm' && hours !== 12) {
        hours += 12;
      } else if (period === 'am' && hours === 12) {
        hours = 0;
      }
    } else {
      // Parse 24-hour time string
      const timeParts = timeStr.split(':');
      hours = parseInt(timeParts[0], 10);
      minutes = parseInt(timeParts[1], 10);
      // seconds = parseInt(timeParts[2], 10);
    }
    if (timeFormat === '12hrs' || timeFormat === '12-hour') {
      period = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
    }
    // No need for an else here because we return in the if above
    if (timeFormat === '24hrs' || timeFormat === '24-hour') {
      // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }
    throw new Error('Invalid time format specified');
  };
  function convertAndFormatDateTime(dateTime, company, profile) {
    if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
    const extractTimezoneName = (tzStr) => {
      const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
      return match ? match[1] : "";
    };
    const fromTimezone = extractTimezoneName(company?.timeZone);
    const toTimezone = extractTimezoneName(profile?.timeZone);
    if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
      console.warn("Invalid timezone provided");
      return "";
    }
    const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
    const dateFormat = "YYYY-MM-DD";
    const timeFormat = "24hrs";
    const formattedDate = converted.format(dateFormat);
    const rawTime = converted.format("HH:mm");
    const formattedTime = convertTime(rawTime, timeFormat);

    return `${formattedDate} ${formattedTime}`
  }
  function formatDateTime(input) {
    const date = new Date(input.replace(" ", "T"));

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return `${months[date.getMonth()]} ${String(date.getDate()).padStart(2, '0')}, ${date.getFullYear()}, ` +
      `${String(date.getHours()).padStart(2, '0')}:` +
      `${String(date.getMinutes()).padStart(2, '0')}`;
  }
  useEffect(() => {
    const socket = getSocket();
    const handleNotification = (data) => {
      const updatedNotification = {
        ...data,
        message: data.subject ? highlightValuesInsideQuotes(data.subject) : data.subject
      };
      setNotification(prevNotifications => {
        const updatedNotifications = [updatedNotification, ...prevNotifications].slice(0, 9);
        return updatedNotifications;
      });
      setUnseenCount(prevCount => prevCount + (data.status === 'unseen' ? 1 : 0));
      setIsNotification(prevState => prevState || data.status === 'unseen');
      if (!notificationIdsShown.has(data.sourceId)) {
        notificationIdsShown.add(data.sourceId);

        const contentsd = (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={iconWrapper}><EmailIcon /></div>
            <div style={{
              lineHeight: 1.4,
              cursor: "pointer"
            }}>
              <div style={{ fontSize: 14, color: "#333", fontWeight: 500 }}>
                You have received a new email
              </div>
              <div role="button"
                tabIndex={0}
                onClick={() => {
                  ViewDetailPage(updatedNotification.sourceId, "INBOX", updatedNotification.linkedBy, updatedNotification.mailServer, updatedNotification.emailActivityId)
                  NotifcationUI.destroy()
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    ViewDetailPage(updatedNotification.sourceId, "INBOX", updatedNotification.linkedBy, updatedNotification.mailServer, updatedNotification.emailActivityId)
                  }
                }}
                style={{
                  fontWeight: 400,
                  color: "#5a5f7d",
                  marginBottom: "4px",
                }}
              >
                {parse(updatedNotification.message)} | <span style={{ color: "#adb4d2" }}>{updatedNotification.fromEmail}</span>
              </div>
            </div>
          </div >
        );
        NotifcationUI.open({
          message: null,
          description: contentsd,
          placement: "bottomRight",
          duration: 5,
          style: {
            borderRadius: 10,
            boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
            padding: "10px 14px",
            width: 360,
          },
        });
      };
    }
    socket.off("email", handleNotification);
    socket.on("email", handleNotification);
    const handleConnect = () => {
      socket.emit("join", profile.userId);
    };
    socket.off("connect", handleConnect);
    socket.on("connect", handleConnect);
    return () => {
      socket.off("email", handleNotification);
      socket.off("connect", handleConnect);
    };
  }, []);
  const content = (
    <AtbdTopDropdwon className="atbd-top-dropdwon nav">
      <Heading as="h5" className="atbd-top-dropdwon__title">
        <span className="title-text">Email</span>
        <Badge className="badge-success" count={unseenCount} />
      </Heading>
      <Scrollbars
        autoHeight
        autoHide
        renderThumbVertical={renderThumb}
        renderView={renderView}
        renderTrackVertical={renderTrackVertical}
      >
        <ul className="atbd-top-dropdwon__nav notification-list">
          {notification && notification.map((item) => {
            const convertedDate = convertAndFormatDateTime(item.actionDate, companyProfile, profile)
            const realTime = formatDateTime(convertedDate)
            const createdTime = new Date(realTime);
            const tzString = profile?.timeZone || "(GMT+0:00) UTC";
            const tz = extractTimeZoneName(tzString);
            const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
            const currentTime = new Date(currentrealTime);
            const timeDifference = Math.floor((currentTime - createdTime) / (1000 * 60)); // Difference in minutes
            // Function to format time difference
            const formatTimeDifference = () => {
              if (timeDifference < 1) {
                return 'Just now';
              }
              if (timeDifference < 60) {
                return `${timeDifference} minute${timeDifference !== 1 ? 's' : ''} ago`;
              }
              if (timeDifference < 1440) { // Less than a day
                const hours = Math.floor(timeDifference / 60);
                return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
              }
              // More than a day
              const days = Math.floor(timeDifference / 1440);
              return `${days} day${days !== 1 ? 's' : ''} ago`;
            };
            const formattedTimeDifference = formatTimeDifference();
            return (
              <li key={item.sourceId}>
                <Link to={combinedUrl} onClick={() => ViewDetailPage(item.sourceId, "INBOX", item.linkedBy, item.mailServer, item.emailActivityId)}>
                  <div className="atbd-top-dropdwon__content notifications">
                    <div className="notification-icon bg-primary">
                      <EmailIcon />
                    </div>
                    <div className="notification-content d-flex">
                      <div className="notification-text">
                        <Heading as="h5">
                          {parse(item.message)}
                        </Heading>
                        <p>{formattedTimeDifference} | <span>{item.fromEmail}</span></p>
                      </div>
                      <div className="notification-status">
                        <Badge dot={item.status === "unseen"} />
                      </div>
                    </div>
                  </div>
                </Link>
              </li>
            )
          })}
        </ul>
      </Scrollbars>
      <Link className="btn-seeAll" to={(storeSubcription?.isActive && !edit) ? "/Home/email-notifications" : combinedUrl} onClick={() => handleChange(false, "/Home/email-notifications")}>
        See all incoming activity
      </Link>
    </AtbdTopDropdwon>
  );
  return (
    <>
      <div className="notification" title='Emails'>
        {edit ?
          <Badge dot={isNotification} offset={[-8, -5]}>
            <span className="head-example" style={{ cursor: "not-allowed" }}>
              <EmailIcon height={24} width={20} />
            </span>
          </Badge>
          : <Popover
            placement="bottomLeft"
            content={content}
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
          >
            <Badge dot={isNotification} offset={[-8, -5]}>
              <span className="head-example" style={{ cursor: "pointer" }}>
                <EmailIcon height={24} width={20} />
              </span>
            </Badge>
          </Popover>}
      </div>
      <Drawer
        className='Drawer-Header-Pages'
        bodyStyle={{ padding: 0 }}
        closable={false}
        placement="right"
        title="Email Message"
        open={emailPopup}
        extra={
          < Space >
            <div className='Hover-Refresh2 back-hover1 able-style'
              role="button"
              tabIndex={0} title='Close'
              onClick={() => emailClose()}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  emailClose()
                }
              }}
              aria-label='Close'
            > <CancelIcon width={24} height={24} /></div>
          </Space >
        }
        width="70%"
      // width="100%"
      >
        <MailDetailView detailsId={emailOpenId} detailsPage={popupType} Comefrom="Entitys" />
      </Drawer>
      {confirmPopup && <EditNavPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} linkUrl={{ url: linkUrl, type: "Normal" }} />}
    </>
  );
}

export default NotificationBox;